import * as React from "react"

export interface SubscriptionsBlockProps {
  readonly kind: "subscription_block"
}

type HarcodedSubscriptionBlockRowValueProps = {
  label: string
  srLabel?: string
}

type HarcodedSubscriptionBlockRowProps = {
  row: string,
  title: string,
  values: HarcodedSubscriptionBlockRowValueProps[]
}

const labelPrefix = [
  'Bij jeugd abonnement',
  'Bij compleet abonnement',
  'Bij instap abonnement'
]

const HarcodedSubscriptionBlockRow = (props: HarcodedSubscriptionBlockRowProps): JSX.Element => {
  return (
    <div className="ms__row ms__row--content">
      <div className="ms__cell ms__cell--subtitle">
        <h3 className="ms__subtitle">{props.title}</h3>
      </div>

      {props.values.map((v, i) => {
        return (
          <div className="ms__cell ms__cell--content" key={`ms-${props.row}-${i}`}>
            <p className="sr-text">{`${labelPrefix[i]}: ${v.srLabel}`}</p>
            <p className="ms__value" aria-hidden="true">{v.label == 'true' ? <svg className="ms__icon" width="32" height="32"><use xlinkHref="#icon--ms-check"></use></svg> : v.label}</p>
          </div>
        )
      })}
    </div>
  )
}

export const HarcodedSubscriptionBlock = (): JSX.Element => {
  return (
    <section className="block block--memberships">
      <div className="block__inner">
        <div className="memberships ms">
          <header className="ms__row ms__row--header">
            <h2 className="sr-text">Kies het abonnement dat bij jou past</h2>

            <div className="ms__cell ms__cell--title">
              <span className="sr-text">Type abonnementen</span>
            </div>

            <div className="ms__cell ms__cell--header">
              <p className="ms__title">Jeugd</p>
              <p className="ms__intro">
                <span className="sr-text">Dit abonnement is: gratis voor 0 tot 18 jarigen</span>
                <span aria-hidden="true">0–18 jaar Gratis</span>
              </p>
            </div>

            <div className="ms__cell ms__cell--header">
              <p className="ms__title">Compleet</p>
              <p className="ms__intro">
                <span className="sr-text">Dit abonnement is: € 4 per maand voor 18 tot 25 jarigen, € 5 per maand voor 25 jarigen en ouder</span>
                <span aria-hidden="true">
                  18–25 jaar € 4/maand<br/>
                  25+ jaar € 5/maand
                </span>
              </p>
            </div>

            <div className="ms__cell ms__cell--header">
              <p className="ms__title">Instap</p>
              <p className="ms__intro">
                <span className="sr-text">Dit abonnement is: gratis voor 18 jarigen en ouder</span>
                <span aria-hidden="true">18+ jaar Gratis</span>
              </p>
            </div>
          </header>

          {HarcodedSubscriptionBlockRow({
            row: '1',
            title: '15 boeken per keer, boetevrij',
            values: [
              {label: 'true', srLabel: 'Inbegrepen'},
              {label: 'true', srLabel: 'Inbegrepen'},
              {label: "€ 3,50 per boek", srLabel: 'Niet inbegrepen, kosten € 3,50 per boek'},
            ]
          })}

          {HarcodedSubscriptionBlockRow({
            row: '2',
            title: '10 e-books en luisterboeken per 3 weken',
            values: [
              {label: 'true', srLabel: 'Inbegrepen'},
              {label: 'true', srLabel: 'Inbegrepen'},
              {label: "Stopt na 2 maanden", srLabel: 'Niet inbegrepen, proefperiode stopt na 2 maanden'},
            ]
          })}

          {HarcodedSubscriptionBlockRow({
            row: '3',
            title: '5 online tijdschriften per 3 weken',
            values: [
              {label: 'true', srLabel: 'Inbegrepen'},
              {label: 'true', srLabel: 'Inbegrepen'},
              {label: "Stopt na 2 maanden", srLabel: 'Niet inbegrepen, proefperiode stopt na 2 maanden'},
            ]
          })}

          {HarcodedSubscriptionBlockRow({
            row: '4',
            title: '160 online cursussen en bronnen',
            values: [
              {label: 'true', srLabel: 'Inbegrepen'},
              {label: 'true', srLabel: 'Inbegrepen'},
              {label: 'true', srLabel: 'Inbegrepen'}
            ]
          })}

          {HarcodedSubscriptionBlockRow({
            row: '5',
            title: 'Computer, printer, werk- en studieplekken',
            values: [
              {label: 'true', srLabel: 'Inbegrepen'},
              {label: 'true', srLabel: 'Inbegrepen'},
              {label: 'true', srLabel: 'Inbegrepen'}
            ]
          })}

          {HarcodedSubscriptionBlockRow({
            row: '6',
            title: 'Korting op activiteiten',
            values: [
              {label: 'true', srLabel: 'Inbegrepen'},
              {label: 'true', srLabel: 'Inbegrepen'},
              {label: 'true', srLabel: 'Inbegrepen'}
            ]
          })}

          <footer className="ms__row ms__row--footer ms__row--desktop">
            <div className="ms__cell ms__cell--title">
              <span className="sr-text">Lid worden?</span>
            </div>

            <div className="ms__cell ms__cell--footer">
              <a href="https://probiblio.hostedwise.nl/wise-apps/opac/6190/subscription/regular" className="button">
                Kies Jeugd
              </a>
            </div>
            <div className="ms__cell ms__cell--footer">
              <a href="https://probiblio.hostedwise.nl/wise-apps/opac/6190/subscription/regular" className="button">
                Kies Compleet
              </a>
            </div>
            <div className="ms__cell ms__cell--footer">
              <a href="https://probiblio.hostedwise.nl/wise-apps/opac/6190/subscription/regular" className="button">
                Kies Instap
              </a>
            </div>
          </footer>

          <footer className="ms__row ms__row--footer ms__row--mobile">
            <div className="ms__cell ms__cell--title">
              <span className="sr-text">Lid worden?</span>
            </div>

            <div className="ms__cell ms__cell--footer">
              <a href="https://probiblio.hostedwise.nl/wise-apps/opac/6190/subscription/regular" className="button">
                Ga naar inschrijfformulier
              </a>
            </div>
          </footer>
        </div>
      </div>
    </section>
  )
}
